export default __webpack_public_path__ + "static/media/rocket_anim_138.23b10fbf.png";